import BookingTableContainer from "./BookingTableContainer";
import BookingTableStore from "./BookingTableStore";

export default BookingTableStore(BookingTableContainer);
